import React from 'react';
import { ProductCard } from '../components/ProductCard';
import { usePortalContext } from '../context/PortalContext';

const Products = (): JSX.Element => {
  const { products } = usePortalContext();

  return (
    <div>
      <h1 className="section-title">Products</h1>
      <p className="muted">
        Explicit routing keeps product surfaces predictable. Future products will plug into this
        view without changing the platform contract.
      </p>
      {products.length === 0 ? (
        <div className="card">
          <p className="muted">
            No products are assigned to this tenant. If you believe you should see Edinshall Audit
            or another product, please <a href="/support">contact support</a>.
          </p>
        </div>
      ) : (
        <div className="grid columns-2" style={{ marginTop: '12px' }}>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Products;
